import FESegmentUtils from '@spothero/utils/segment';
import SHGlobals from 'sh-globals';

/**
 * Utilities for working with segment.
 * @module SegmentUtils
 */
const SegmentUtils = {
    /**
     * Sends tracking event data to Segment.
     * @static
     * @function track
     * @param {Object} [data={}] - The data to send to segment.
     * @param {String} data.event - The event name.
     * @param {Object} [data.properties=null] - The event properties object. See the properties object information <a href="https://segment.com/docs/spec/track/#properties" target="_blank">here</a> for details.
     * @param {Object} [data.additionalOptions=null] - Additional options to send with the event.
     * @example
     * SegmentUtils.track({
     *     event: 'Searched',
     *     properties: {
     *         city: 'Chicago'
     *     }
     * });
     * @returns {void}
     */
    track(data) {
        FESegmentUtils.track({
            ...data,
            properties: {
                ...data.properties,
                'device platform': SHGlobals.isMobile ? 'mobile web' : 'desktop web'
            }
        });
    }
};

export default {
    ...FESegmentUtils,
    ...SegmentUtils
};



// WEBPACK FOOTER //
// ./spothero/static/main/js/utils/segment.js